import React, { useState, useEffect } from 'react';
import { fetchBankSurveyAnalytics } from '../../api/client';
import BankSurveyAnalytics from '../BankSurveyAnalytics/BankSurveyAnalytics';
import BankSurveyList from '../BankSurveyList/BankSurveyList';

export default function BankSurveyTab() {
  const [analyticsData, setAnalyticsData] = useState(null);

  useEffect(() => {
    fetchBankSurveyAnalytics()
      .then((res) => setAnalyticsData(res.data))
      .catch(() => setAnalyticsData(null));
  }, []);

  return (
    <div>
      <BankSurveyAnalytics analytics={analyticsData} />
      <BankSurveyList />
    </div>
  );
}
